@use '@lib/assets/styles/main.scss' as *;

.counters {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
  padding-bottom: 32px;
}

.countersRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.counterItem {
  @extend %whiteBlock;
  padding: 16px 24px;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 16px;
}

.title {
  color: $gray60;
  margin-bottom: 2px;
  display: block;
}

.counter {
  line-height: 34px;
}

.solvedCounter {
  cursor: help;
}

.counterItemIconCircle {
  .counterItem:hover & {
      animation: iconTwitch 0.5s ease-in-out;
  }
}

.counterItemIcon {
  .counterItem:hover & {
      animation: iconTilt 0.6s ease-in-out;
  }
}
